import { EdgeReportMessageRepository } from '@/modules/connect/infra'
import type { ReportMessage } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeReportMessage(): ReportMessage {
  return new EdgeReportMessageRepository(makeSupabaseEdgeHttpClient()).execute
}
